export default __webpack_public_path__ + "static/media/assistant-restaurant-leader-milestone-tracker-header.bba946d1.png";